import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProjectHelper from 'src/app/helpers/project-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import { Project } from 'src/app/model/project/project';
import { SubProject } from 'src/app/model/project/sub-project';

export class ProjectTabsContainerHelper {
  private constructor() {}

  static copyRecurringInternalInfoFromMostRecentSubProject(
    copyTarget: SubProject,
    project: Project
  ): void {
    if (project == null || !CollectionHelper.isPopulated(project.subProjects)) {
      return;
    }

    const mostRecentSubProjectWithRecurringInternalInfo =
      ProjectTabsContainerHelper.getMostRecentSubProjectWithRecurringInternalInfo(
        project
      );

    if (mostRecentSubProjectWithRecurringInternalInfo != null) {
      copyTarget.recurringInternalInfo = true;
      copyTarget.internalInfo =
        mostRecentSubProjectWithRecurringInternalInfo.internalInfo;
    }
  }

  private static getMostRecentSubProjectWithRecurringInternalInfo(
    project: Project
  ): SubProject {
    let toReturn: SubProject = null;
    project.subProjects.forEach((subProject) => {
      if (
        !subProject.archived &&
        subProject.recurringInternalInfo &&
        !StringHelper.isEmptyOrWhiteSpace(subProject.internalInfo)
      ) {
        if (toReturn == null) {
          toReturn = subProject;
        } else {
          toReturn = ProjectHelper.maxAccordingToDate(
            toReturn,
            subProject,
            'currentCreatedAt'
          );
        }
      }
    });
    return toReturn;
  }
}
